<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="content">
    <Header :tabIndex="tabIndex"></Header>
    <el-image
      class="header_bg"
      fit="cover"
      src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/wt_1.png"
    ></el-image>
    <!-- <el-image
      class="header_bg1"
      fit="cover"
      src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/wt_2.png"
    ></el-image> -->
    <div class="nav">
      <div class="nav_head">
        <div class="title">常见问题</div>
        <div class="title1">frequently asked questions</div>
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="item_head" @click="openQuestion(index)">
            <div class="left">
              {{ item.question }}
            </div>
            <div class="right">
              <img
                v-if="!item.isOpen"
                class="img"
                src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/wt_3.png"
                alt=""
              />
              <img
                v-else
                class="img"
                src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/question/wt_4.png"
                alt=""
              />
            </div>
          </div>
          <div class="item_info" v-if="item.isOpen">
            <div class="text">
              {{ item.answer }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      tabIndex: 4,
      list: [
        {
          question: "01 . 什么是二白机器人？",
          answer: "二白机器人是一个可养成、可陪伴、共同成长的数字生命体。",
          isOpen: false,
        },
        {
          question: "02 . 二白的由来是什么？",
          answer:
            "2018年5月17日，毛老师做出了第一个“二白”。 \n他的梦想，是创造一个现实版的《机器人总动员》。 \n后来，海薇成为了它的第一个女主人。\n用短视频记录着和二白的日常，慢慢走进了很多人的心里。",
          isOpen: false,
        },
        {
          question: "03 . 二白机器人可以用来做什么？",
          answer:
            "它是个会说话的情绪搭子、是一只很会逗你的小萌宠。 \n主打有趣的对话陪伴，小巧可爱、自带网络。\n不仅能给你提供情绪价值，还能进阶实现控制家电、习惯养成、帮你传话等功能。",
          isOpen: false,
        },
        {
          question: "04 . 二白机器人和二白Mini机器人是什么关系？",
          answer:
            "二白机器人是全屋情绪管家，是家居生活助手和家庭情感中枢。\n二白Mini机器人是随身伙伴，即时养成触手可及的陪伴。\n二白机器人是家庭场景的大搭子，二白Min是随时随地的小搭子。",
          isOpen: false,
        },
        {
          question: "05 . 二白Mini机器人创始版和限定版有什么区别？",
          answer: "两者在功能上完全一致，仅在福利上有所区别。",
          isOpen: false,
        },
      ],
    }
  },
  mounted() {},
  methods: {
    openQuestion(e) {
      this.list[e].isOpen = !this.list[e].isOpen
    },
     returnPage() {
       this.$router.go(-1);
    }
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding-top: 100px;
  position: relative;
  .header_bg {
    width: 50%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  .header_bg1 {
    width: 50%;
    position: absolute;
    top: 20%;
    right: 0;
    z-index: 1;
  }
  .nav {
    padding: 0 160px;
    margin-bottom: 30px;
    z-index: 100;
    position: relative;
    z-index: 10;
    .nav_head {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-bottom: 50px;
      .title {
        color: #fff;
        font-size: calc(70px * var(--scale));
        margin-bottom: 20px;
      }
      .title1 {
        color: #808183;
        font-size: calc(22px * var(--scale));
      }
    }
    .list {
      width: 100%;
      .item {
        width: 100%;
        padding: 40px;
        box-sizing: border-box;
        background-color: #0f0f128a;
        border-radius: 20px;
        margin-bottom: 30px;
        .item_head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .left {
            color: #fff;
            font-size: calc(26px * var(--scale));
          }
          .right {
            .img {
              width: 30px;
              height: 30px;
            }
          }
        }
        .item_info {
          .text {
            color: #ababad;
            font-size: calc(20px * var(--scale));
            margin-top: 20px;
            text-align-last: left;
            white-space: pre-line;
          }
        }
      }
    }
  }
}
</style>
